/* B4P – vídeos na página do produto (automático). Mímir, 03/11/2026
   Lê as páginas que já têm os carrosséis/stories, junta os vídeos em que este produto está vinculado
   e monta um carrossel igual aos outros. O índice fica guardado 30 min no navegador para não buscar de novo. */
(function () {
  if (window.B4PVPV) return; window.B4PVPV = true;
  var TTL = 30 * 60 * 1000;
  function handleOf(href) {
    try { var m = new URL(href, location.origin).pathname.match(/\/products\/([^\/?#]+)/); return m ? decodeURIComponent(m[1]) : null; } catch (_) { return null; }
  }
  function handlesIn(node) {
    var hs = [];
    node.querySelectorAll('a[href*="/products/"]').forEach(function (a) { var h = handleOf(a.getAttribute('href')); if (h && hs.indexOf(h) < 0) hs.push(h); });
    return hs;
  }
  // Story vira um card de carrossel (mesma estrutura dos carrosséis)
  function storyCard(d, st, tpl) {
    var ps = Array.prototype.slice.call(tpl.content.querySelectorAll('.b4pv-p'));
    var card = d.createElement('div'); card.className = 'b4pv-card'; card.setAttribute('data-b4pv-card', '');
    var th = d.createElement('div'); th.className = 'b4pv-thumb'; th.setAttribute('role', 'button'); th.setAttribute('tabindex', '-1');
    ['data-b4pv-src', 'data-b4pv-hls', 'data-b4pv-poster'].forEach(function (a) { if (st.hasAttribute(a)) th.setAttribute(a, st.getAttribute(a)); });
    var img = d.createElement('img'); img.src = st.getAttribute('data-b4pv-poster') || ''; img.alt = ''; img.loading = 'lazy'; img.setAttribute('draggable', 'false');
    var v = d.createElement('video'); v.muted = true; v.setAttribute('muted', ''); v.setAttribute('loop', ''); v.setAttribute('playsinline', ''); v.setAttribute('preload', 'none'); v.setAttribute('aria-hidden', 'true');
    var mb = d.createElement('button'); mb.type = 'button'; mb.className = 'b4pv-mute'; mb.setAttribute('aria-label', 'Ativar som');
    th.appendChild(img); th.appendChild(v); th.appendChild(mb); card.appendChild(th);
    var box = d.createElement('div'); box.className = 'b4pv-prod';
    if (ps.length > 1) {
      var list = d.createElement('div'); list.className = 'b4pv-prod__list'; list.hidden = true;
      ps.forEach(function (p) { list.appendChild(p.cloneNode(true)); }); box.appendChild(list);
    }
    var main = d.createElement('div'); main.className = 'b4pv-prod__main'; main.appendChild(ps[0].cloneNode(true));
    if (ps.length > 1) {
      var tg = d.createElement('button'); tg.type = 'button'; tg.className = 'b4pv-prod__tog'; tg.setAttribute('aria-expanded', 'false'); tg.setAttribute('aria-label', 'Ver os ' + ps.length + ' produtos do vídeo');
      tg.innerHTML = '<svg viewBox="0 0 24 24"><path d="M5 15l7-7 7 7" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>';
      main.appendChild(tg);
    }
    box.appendChild(main); card.appendChild(box);
    return card.outerHTML;
  }
  function index(sources) {
    var key = 'b4pv_idx_' + ((window.Shopify && Shopify.theme && Shopify.theme.id) || '');
    try { var c = JSON.parse(localStorage.getItem(key) || 'null'); if (c && c.src === sources.join('|') && Date.now() - c.t < TTL) return Promise.resolve(c.items); } catch (_) {}
    return Promise.all(sources.map(function (u) {
      return fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (htmls) {
      var items = [], seen = {};
      htmls.forEach(function (h) {
        if (!h) return;
        var d = new DOMParser().parseFromString(h, 'text/html');
        d.querySelectorAll('[data-b4pv-card]').forEach(function (card) {
          var th = card.querySelector('.b4pv-thumb'), k = th && th.getAttribute('data-b4pv-src');
          if (!k || seen[k]) return;
          var hs = handlesIn(card); if (!hs.length) return;
          seen[k] = 1; card.classList.remove('is-active'); card.removeAttribute('style');
          items.push({ h: hs, html: card.outerHTML });
        });
        d.querySelectorAll('.b4pv-story').forEach(function (st) {
          var k = st.getAttribute('data-b4pv-src'), tpl = st.querySelector('template.b4pv-tpl');
          if (!k || seen[k] || !tpl) return;
          var hs = handlesIn(tpl.content); if (!hs.length) return;
          seen[k] = 1; items.push({ h: hs, html: storyCard(d, st, tpl) });
        });
      });
      try { localStorage.setItem(key, JSON.stringify({ t: Date.now(), src: sources.join('|'), items: items })); } catch (_) {}
      return items;
    });
  }
  function render(root, mine) {
    root.classList.add('b4pv-car'); if (root.dataset.pad) root.classList.add(root.dataset.pad);
    var head = '';
    if (root.dataset.heading) head = '<div class="b4pv-car__head page-width"><h2 class="b4pv-car__title h2"></h2></div>';
    root.innerHTML = head + '<div class="b4pv-car__stage" tabindex="0" aria-roledescription="carrossel"></div>';
    if (head) root.querySelector('.b4pv-car__title').textContent = root.dataset.heading;
    var stage = root.querySelector('.b4pv-car__stage');
    stage.setAttribute('aria-label', root.dataset.heading || 'Vídeos');
    stage.innerHTML = mine.map(function (i) { return i.html; }).join('');
    root.setAttribute('data-autoplay', 'true');
    root.setAttribute('data-b4pv-carousel', '');
    (function wait(n) { if (window.B4PV) window.B4PV.init(root.parentNode); else if (n < 100) setTimeout(function () { wait(n + 1); }, 100); })(0);
  }
  function init(root) {
    if (root._pv) return; root._pv = true;
    var handle = root.dataset.handle;
    var sources = (root.dataset.sources || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    if (!handle || !sources.length) return;
    var started = false;
    function start() {
      if (started) return; started = true;
      index(sources).then(function (items) {
        var mine = items.filter(function (it) { return it.h.indexOf(handle) > -1; });
        if (mine.length) render(root, mine);
      });
    }
    // só busca quando a cliente chega perto da seção (não pesa o carregamento da página)
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); start(); } }, { rootMargin: '900px 0px' });
      io.observe(root);
    } else start();
  }
  function all() { document.querySelectorAll('[data-b4pv-pv]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
